import { Button, Form, Row, Col, Input, InputNumber } from "antd";
import { useRef } from "react";
import { ExpandOutlined } from "@ant-design/icons";
import LocationPicker from "./LocationPicker";
import SingleSelector from "./SingleSelector";
import {
  validateLatitude,
  validateLongitude,
  validatePositiveDecimal,
  validatePositiveDecimalGreaterThanZero,
} from "../utils/validators";

const { TextArea } = Input;

export default function EmissionPointBasicInfoTab({
  form,
  mode,
  markerPosition,
  showMap,
  mapRefreshKey,
  setSmallMap,
  openExpandedMap,
  updateMarkerPosition,
  devicesWithAnemometer,
  devicesLoading,
}) {
  const basicInfoRef = useRef(null);

  return (
    <div ref={basicInfoRef} style={{ padding: 16 }}>
      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: "Name is required" }]}
          >
            <Input placeholder="Enter name" autoComplete="off" />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item
            label="Device with anemometer"
            name="anemometerDeviceId"
            rules={[
              { required: true, message: "Please select a device with anemometer" },
            ]}
          >
            <SingleSelector
              items={devicesWithAnemometer}
              idKey="id"
              labelKey="name"
              placeholder={
                devicesLoading
                  ? "Loading devices..."
                  : "Select device"
              }
              width="100%"
              disabled={devicesLoading || !devicesWithAnemometer.length}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Form.Item
            label="Height (m)"
            name="height"
            rules={[
              { required: true, message: "Height is required" },
              { validator: validatePositiveDecimal },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              step={0.01}
              placeholder="Enter height"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            label="Concentration Height (m)"
            name="concentrationHeight"
            rules={[
              { required: true, message: "Concentration height is required" },
              { validator: validatePositiveDecimal },
            ]}
          >
            <InputNumber style={{ width: "100%" }} step={0.01} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Form.Item
            label="Wind threshold (mph)"
            name="windThreshold"
            rules={[
              { required: true, message: "Enter wind threshold" },
              { validator: validatePositiveDecimalGreaterThanZero },
            ]}
          >
            <InputNumber style={{ width: "100%" }} step={0.01} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Form.Item
            label="Latitude (º)"
            name="latitude"
            rules={[
              { required: true, message: "Enter latitude" },
              { validator: validateLatitude },
            ]}
          >
            <InputNumber style={{ width: "100%" }} step={0.000001} />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item
            label="Longitude (º)"
            name="longitude"
            rules={[
              { required: true, message: "Enter longitude" },
              { validator: validateLongitude },
            ]}
          >
            <InputNumber style={{ width: "100%" }} step={0.000001} />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item label="Select location on map">
            <div style={{ position: "relative", height: 220 }}>
              <Button
                type="default"
                size="small"
                icon={<ExpandOutlined />}
                style={{
                  position: "absolute",
                  top: 12,
                  right: 12,
                  zIndex: 1000,
                  background: "white",
                  border: "1px solid #ddd",
                }}
                onClick={openExpandedMap}
              >
                Expand
              </Button>

              {showMap && (
                <div style={{ height: "100%" }}>
                  <LocationPicker
                    value={markerPosition}
                    onChange={(pos) => updateMarkerPosition(pos, form)}
                    disabled={false}
                    setContainerMap={setSmallMap}
                    forceRefresh={mapRefreshKey}
                  />
                </div>
              )}
            </div>
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
}
